import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { ChartModule } from '@ddt-web/chart';
import { SharedModule } from '@ddt-web/common';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { DomModule } from '@ddt-web/dom';

import { AssetAllocationSlimComponent } from './components/asset-allocation-slim';
import { AssetAllocationComponent } from './components/asset-allocation/asset-allocation.component';

@NgModule({
	declarations: [
		AssetAllocationComponent,
		AssetAllocationSlimComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		DisclosureModule,
		CwpNgFrameworkModule,
		ChartModule,
		CoreModule,
		DataServiceModule,
		DomModule,
		DzProgressSpinnerModule
	],
	exports: [
		AssetAllocationComponent,
		AssetAllocationSlimComponent
	]
})
export class AssetAllocationModule { }
